var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImageEnhancement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H18V4H14V6H18V10H20V6H24V4H20V0Z",
    fill: "#1E63F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.4118L8.5 9L13.3642 15.2948L16 12L22 19.5V8H24V24H0V4H12V6H2V17.4118Z",
    fill: "#1E63F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageEnhancement);
export default __webpack_public_path__ + "static/media/icon-imageEnhancement.ff8c6137317e3c4fb353df2621409c42.svg";
export { ForwardRef as ReactComponent };